import { UiSchema } from "@rjsf/utils";

export const parseZipCodes = (value: unknown): string[] =>
  typeof value === "string"
    ? value
        .split(",")
        .map((zipCode) => zipCode.trim())
        .filter((zipCode) => zipCode !== "")
    : [];

/** An empty zip code or a field without whitelist counts as allowed. */
export const isZipCodeAllowed = (zipCode: string, allowedZipCodes: string[]): boolean =>
  allowedZipCodes.length === 0 || zipCode.trim() === "" || allowedZipCodes.includes(zipCode.trim());

/** True if a filled zip code field does not match its whitelist — mirrors the backend check. */
export const isZipCodeBlocked = (uiSchema: UiSchema | undefined, formData: Record<string, unknown>): boolean =>
  Object.entries(uiSchema ?? {}).some(([property, entry]) => {
    if (entry?.["ui:field"] !== "zipCode") return false;
    const value = formData?.[property];
    return typeof value === "string" && !isZipCodeAllowed(value, parseZipCodes(entry?.["ui:options"]?.zipCodes));
  });
